/* eslint-disable max-lines */
import columnTypes from '../columnTypes.js';
import types from '../types.js';

const aomTables = [
  {
    key: 'aom-servers',
    name: 'AOM Servers',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Server Name',
        type: types.text,
      },
      {
        source: 'StoragePlatform',
        rename: 'Storage Platform',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Server ID' }],
  },
  {
    key: 'aom-groups',
    name: 'AOM Groups',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Group Name',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'GroupScope',
        rename: 'Scope',
        type: types.text,
      },
      {
        source: 'GroupType',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'shortName',
        rename: 'Domain Short Name',
        type: types.text,
      },
      {
        source: 'TotalChildren',
        rename: 'Total Children',
        type: types.number,
      },
      {
        source: 'NumSubGroups',
        rename: 'Sub-Groups',
        type: types.number,
      },
      {
        source: 'TotalUsers',
        rename: 'Total Users',
        type: types.number,
      },
      {
        source: 'AdminUsers',
        rename: 'Admin Users',
        type: types.number,
      },
      {
        source: 'RegularUsers',
        rename: 'Regular Users',
        type: types.number,
      },
      {
        source: 'UniqueUsers',
        rename: 'Unique Users',
        type: types.number,
      },
      {
        source: 'SystemAccounts',
        rename: 'System Accounts',
        type: types.number,
      },
      {
        source: 'GroupDepth',
        rename: 'Group Depth',
        type: types.number,
      },
      {
        source: 'SVA',
        rename: 'Stale/Active',
        type: types.text,
      },
      {
        source: 'IsEmpty',
        rename: 'Is Empty',
        type: types.text,
      },
      {
        source: 'CircularReference',
        rename: 'Circular Reference',
        type: types.text,
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'CreateDate',
        rename: 'Create Date',
        type: types.datetime,
      },
      {
        source: 'ModifyDate',
        rename: 'Modify Date',
        type: types.datetime,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Group ID' }],
  },
  {
    key: 'aom-applications',
    name: 'AOM Applications',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'App Name',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: '_Id',
        rename: 'App ID',
      },
    ],
  },
  {
    key: 'aom-accounts',
    name: 'AOM Accounts',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Display Name',
        type: types.text,
      },
      {
        source: 'SamAccountName',
        rename: 'Username',
        type: types.text,
      },
      {
        source: 'Domain',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Status',
        type: types.text,
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: '_Id',
        rename: 'Account ID',
      },
      {
        source: 'AccountType',
        rename: 'Type',
        type: types.text,
      },
    ],
  },
  {
    key: 'aom-collections',
    name: 'AOM Collections',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Collection Name',
        type: types.text,
      },
      {
        source: 'Server',
        type: types.text,
      },
      {
        source: 'RiskScore',
        rename: 'Risk Score',
        type: types.number,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ServerToRemote',
      },
      {
        source: 'ServerType',
      },
      {
        source: 'TotalSize',
      },
      {
        source: 'TotalSubfolderCount',
      },
      {
        source: 'TotalOpenFolders',
      },
      {
        source: 'UniqueOpenFolders',
      },
      {
        source: 'ExcessiveAccess',
      },
      {
        source: 'FoldersWithDirectUserPermission',
      },
      {
        source: 'FoldersWhereUsersHaveFullControl',
      },
      {
        source: 'FoldersWhereGroupsHaveFullControl',
      },
      {
        source: 'MostRecentActivityDate',
      },
      {
        source: 'LowRiskInstances',
      },
      {
        source: 'MediumRiskInstances',
      },
      {
        source: 'HighRiskInstances',
      },
      {
        source: 'ReportDate',
        rename: 'Report Date',
        type: types.date,
      },
      {
        source: 'RiskLevel',
      },
      {
        source: 'EntitlementComplete',
      },
      {
        source: 'GroupCreation',
      },
      {
        source: 'GroupPopulation',
      },
      {
        source: 'NotifyOwner',
      },
      {
        source: 'Remediated',
      },
      {
        source: 'NumberOfObjects',
      },
      {
        source: 'ProposedOwnerReason',
      },
      {
        source: 'AllocatedQuota',
      },
      {
        source: 'RemainingQuota',
      },
      {
        source: 'HasSensitiveData',
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'ProtocolName',
        rename: 'Protocol',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Collection ID' }],
  },
  {
    key: 'aom-approles',
    name: 'AOM Application Roles',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Role Name',
        type: types.text,
      },
      {
        source: 'AppName',
        rename: 'Application',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Role ID' }],
  },
  {
    key: 'aom-group policies',
    name: 'AOM Group Policies',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Policy Name',
        type: types.text,
      },
      {
        source: 'Domain',
        type: types.text,
      },
      {
        source: 'AccountType',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Policy ID' }],
  },
  {
    key: 'aom-functions',
    name: 'AOM Functions',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Function Name',
        type: types.text,
      },
      {
        source: 'AppName',
        rename: 'Application',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Function ID' }],
  },
  {
    key: 'aom-sharepoint',
    name: 'AOM SharePoint Sites',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Site Name',
        type: types.text,
      },
      {
        source: 'URL',
        rename: 'Web URL',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Site ID' }],
  },
  {
    key: 'aom-onedrive',
    name: 'AOM OneDrives',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Drive Name',
        type: types.text,
      },
      {
        source: 'URL',
        rename: 'Web URL',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Drive ID' }],
  },
  {
    key: 'aom-teams',
    name: 'AOM Teams',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Team Name',
        type: types.text,
      },
      {
        source: 'Channels',
        rename: '# of Channels',
        type: types.text,
      },
      {
        source: 'Members',
        rename: '# of Members',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Team ID' }],
  },
  {
    key: 'aom-confluence',
    name: 'AOM Confluence',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Space Name',
        type: types.text,
      },
      {
        source: 'IsOpen',
        rename: 'Is Space Open',
        type: types.text,
      },
      {
        source: 'LastActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'Pages',
        type: types.number,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'IsExcessive',
        rename: 'Is Space Excessive',
        type: types.text,
      },
      {
        source: 'Violations',
        rename: 'Violations',
        type: types.number,
      },
      {
        source: 'OpenPages',
        rename: 'Open Pages',
        type: types.number,
      },
      {
        source: 'ExcessivePages',
        rename: 'ExcessivePages',
        type: types.number,
      },
      {
        source: 'StalePages',
        rename: 'Stale Pages',
        type: types.number,
      },
      {
        source: 'Classification',
        rename: 'Space Classification',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Space ID' }],
  },
  {
    key: 'account-type-engine-rules',
    name: 'Account Type Engine Rules',
    [columnTypes.default.key]: [
      {
        source: 'DisplayOrder',
        type: types.text,
      },
      {
        source: 'Priority',
        type: types.number,
      },
      {
        source: 'Enabled',
        rename: 'Status',
        type: types.boolean,
      },
      {
        source: 'Name',
        type: types.text,
      },
      {
        source: 'Description',
        type: types.text,
      },
      {
        source: 'AccountTypeName',
        rename: 'Account Type',
        type: types.text,
      },
      {
        source: 'LastApplied',
        rename: 'Last Applied Date',
        type: types.date,
      },
      {
        source: 'UpdatedBy',
        rename: 'Last Modified By',
        type: types.text,
      },
      {
        source: 'UpdatedDate',
        rename: 'Last Modified Date',
        type: types.date,
      },
      {
        source: 'CreatedBy',
        rename: 'Created By',
        type: types.text,
      },
      {
        source: 'CreateDate',
        rename: 'Created Date',
        type: types.date,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [
      {
        source: 'RuleId',
        rename: 'Rule ID',
      },
      {
        source: 'AccountTypeId',
        rename: 'Account Type ID',
        type: types.text,
      },
    ],
  },
];

export default [...aomTables];
